// See: https://blog.mgechev.com/2015/02/06/parsing-binary-protocol-data-javascript-typedarrays-blobs/#:~:text=The%20two%20possible%20values%20for,is%20the%20blob%20binary%20type.

import type { IMessageWriter } from '../../../engine/messageWriter'
import { assert } from '../../../lib/assert-sidecar'

import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import type { EVoyageMessage } from './voyageMessageIds'
import { voyageMessageEffectCommand } from './voyageMessageEffectCommand-sidecar'
import { voyageMessageBulletCreate } from './voyageMessageBulletCreate-sidecar'
import { voyageMessageBuyRequest } from './voyageMessageBuyRequest-sidecar'
import { voyageMessageCrewCarry } from './voyageMessageCrewCarry-sidecar'
import { voyageMessageCrewCreate } from './voyageMessageCrewCreate-sidecar'
import { voyageMessageCrewHurt } from './voyageMessageCrewHurt-sidecar'
import { voyageMessageCrewHurtEnergy } from './voyageMessageCrewHurtEnergy-sidecar'
import { voyageMessageCrewMove } from './voyageMessageCrewMove-sidecar'
import { voyageMessageCrewSelected } from './voyageMessageCrewSelected-sidecar'
import { voyageMessageCrewStyle } from './voyageMessageCrewStyle-sidecar'
import { voyageMessageCursor } from './voyageMessageCursor-sidecar'
import { voyageMessageEnemyShipCommand } from './voyageMessageEnemyShipCommand-sidecar'
import { voyageMessageGeneralCommand } from './voyageMessageGeneralCommand-sidecar'
import { voyageMessageHostCommand } from './voyageMessageHostCommand-sidecar'
import { voyageMessageInfoRequest } from './voyageMessageInfoRequest-sidecar'
import { voyageMessageInfoSend } from './voyageMessageInfoSend-sidecar'
import { voyageMessageJettison } from './voyageMessageJettison-sidecar'
import { voyageMessageJump } from './voyageMessageJump-sidecar'
import { voyageMessageMoney } from './voyageMessageMoney-sidecar'
import { voyageMessageShipStatus } from './voyageMessageShipStatus-sidecar'
import { voyageMessageSystemCreate } from './voyageMessageSystemCreate-sidecar'
import { voyageMessageWeaponCommand } from './voyageMessageWeaponCommand-sidecar'

export interface IVoyageMessageHandler {
  voyageMessageId: EVoyageMessage
  process: (m: IMessageWriter, isFromHost: boolean, from: number) => void
  test: () => void
}
let _map: { [key: number]: IVoyageMessageHandler } = {}
let _list: IVoyageMessageHandler[] = []
export function registerAll() {
  register(voyageMessageEffectCommand)
  register(voyageMessageCrewCreate)
  register(voyageMessageCrewCarry)
  register(voyageMessageShipStatus)
  register(voyageMessageHostCommand)
  register(voyageMessageEnemyShipCommand)
  register(voyageMessageGeneralCommand)
  register(voyageMessageCrewMove)
  register(voyageMessageCrewSelected)
  register(voyageMessageCursor)
  register(voyageMessageBulletCreate)
  register(voyageMessageCrewHurt)
  register(voyageMessageInfoRequest)
  register(voyageMessageInfoSend)
  register(voyageMessageWeaponCommand)
  register(voyageMessageSystemCreate)
  register(voyageMessageCrewHurtEnergy)
  register(voyageMessageBuyRequest)
  register(voyageMessageJettison)
  register(voyageMessageJump)
  register(voyageMessageMoney)
  register(voyageMessageCrewStyle)
}
function register(mh: IVoyageMessageHandler) {
  assert.nil(
    _map[mh.voyageMessageId],
    'voyageMessage handler',
    mh.voyageMessageId,
  )
  _map[mh.voyageMessageId] = mh
  _list.push(mh)

  // Test it!
  mh.test()
}

export function process(m: IMessageWriter, skipFrom = false) {
  // TODO: move some of this to engine?
  let from = -1
  if (!skipFrom) {
    let fromB1 = messageWriter.readU8(m)
    let fromB2 = messageWriter.readU8(m)
    from = fromB1 + (fromB2 << 8)
  }

  // Check if this is from the host
  let isFromHost = from === -1 || from === websockets.getHostId()

  let t = messageWriter.peek8(m)

  let handler = _map[t]
  if (handler) {
    handler.process(m, isFromHost, from)
  } else {
    let t1 = messageWriter.read16(m)
    let t2 = messageWriter.read8(m)
    assert.failed('unknown voyageMessage type', t, t1, t2)
  }
}
